import { buildBrand } from 'brands';

const apiUrl = process.env.REACT_APP_API_URL;

const config = {
  // Build info
  version: process.env.REACT_APP_VERSION,
  buildDateTime: process.env.REACT_APP_BUILD_DATE_TIME,

  // Configuration
  env: process.env.NODE_ENV,
  apiUrl,
  appUrl: process.env.REACT_APP_URL,
  appName: buildBrand.name,
  landingDomain: process.env.REACT_APP_LANDING_DOMAIN,
  appUrlRegex: process.env.REACT_APP_APP_URL_REGEX ? new RegExp(process.env.REACT_APP_APP_URL_REGEX) : null,

  defaultTypingDebounce: 300,

  // Services
  bugsnag: {
    key: process.env.REACT_APP_BUGSNAG_KEY,
    logger: process.env.REACT_APP_BUGSNAG_LOGGER === 'true',
  },
  ga: {
    enabled: process.env.REACT_APP_GA_ENABLED === 'true',
    debug: process.env.REACT_APP_GA_DEBUG === 'true',
    testMode: process.env.REACT_APP_GA_TEST_MODE === 'true',
    trackingId: process.env.REACT_APP_GA_TRACKING_ID,
  },
  zendesk: {
    enabled: process.env.REACT_APP_ZENDESK_ENABLED === 'true' && process.env.REACT_APP_ZENDESK_KEY,
    key: process.env.REACT_APP_ZENDESK_KEY,
  },
  intercom: {
    enabled: process.env.REACT_APP_INTERCOM_ENABLED === 'true' && !!process.env.REACT_APP_INTERCOM_ID,
    appId: process.env.REACT_APP_INTERCOM_ID,
    iosApiKey: process.env.REACT_APP_INTERCOM_IOS_API_KEY,
    androidApiKey: process.env.REACT_APP_INTERCOM_ANDROID_API_KEY,
  },
  pusher: {
    key: process.env.REACT_APP_PUSHER_KEY,
    cluster: process.env.REACT_APP_PUSHER_CLUSTER,
    tls: process.env.REACT_APP_PUSHER_TLS,
    authEndpoint: `${apiUrl}/broadcasting/auth`,
  },
  passport: {
    clientId: process.env.REACT_APP_PASSPORT_CLIENT_ID,
  },
  talkjs: {
    appId: process.env.REACT_APP_TALKJS_APP_ID,
  },
  tinymce: {
    key: process.env.REACT_APP_TINYMCE_KEY,
  },
  uploadcare: {
    key: process.env.REACT_APP_UPLOADCARE_PUBLIC_KEY,
  },
  microsoft: {
    clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID,
    redirectUri: `${process.env.REACT_APP_URL.replace(/\/+$/, '')}/manage/settings/sharepoint`,
  },
  mui: {
    licenseKey: process.env.REACT_APP_MUI_LICENSE_KEY,
  },
};

export default config;
